import type { ErrorCode } from 'bundles/compound-assessments/constants';

export type StepState = {
  isSubmitting?: boolean | null;
  isSaving?: boolean | null;
  isAutoSaving?: boolean | null;
  isDeadlineExpired?: boolean | null;
  showSubmitSuccessModal?: boolean | null;
  showValidation?: boolean | null;
  errorCode?: ErrorCode | null;
};

export type StepStateKey = {
  stepId: string;
  itemId: string;
  courseId: string;
  userId: number;
};

export const DefaultState: StepState = Object.freeze({
  isSaving: false,
  isSubmitting: false,
  isAutoSaving: false,
  showSubmitSuccessModal: false,
  showValidation: false,
  isDeadlineExpired: false,
  errorCode: null,
});
